// Autosave is a per-device preference, on by default. Browser automation leaves
// it off unless a test turns it on, so scripted edits control when a save happens.
const KEY = 'aviseraplanner.autosave';
export const AUTOSAVE_NOTE = 'Autosaved';
export const AUTOSAVE_IDLE_MS = 4000;

export function autosaveEnabled() {
  let stored = null;
  try { stored = localStorage.getItem(KEY); } catch { /* storage unavailable: use the default */ }
  if (stored === 'on') return true;
  if (stored === 'off') return false;
  return typeof navigator === 'undefined' || !navigator.webdriver;
}

export function setAutosaveEnabled(value) {
  try { localStorage.setItem(KEY, value ? 'on' : 'off'); } catch { /* the choice lasts for this page only */ }
}

/** Wait longer after each failed attempt, up to a minute, so a broken connection is not hammered. */
export const autosaveDelay = failures => Math.min(60000, AUTOSAVE_IDLE_MS * 2 ** Math.max(0, failures));
